import { Box, CircularProgress } from "@mui/material";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

interface ChatDatePickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  loading?: boolean;
}

export const ChatDatePicker = ({
  value,
  onChange,
  loading = false,
}: ChatDatePickerProps) => {
  return (
    <Box
      sx={{
        width: 150,
        height: "40px",
        position: "relative",
        
        borderRadius: "20px",
        backgroundColor: "#fff",
        border: "1px solid rgba(148,163,184,0.35)",
        overflow: "hidden", 
        transition: "border-color 0.2s ease",

        "&:hover": {
          borderColor: "#3b82f6",
        },
        "&:focus-within": {
          borderColor: "#2563eb",
        },

        "& .rs-picker.custom-rs-picker": {
          width: "100% !important",
          height: "100% !important",
          outline: "none !important",
        },

        "& .rs-picker-toggle, & .rs-input-group, & .rs-input": {
          height: "100% !important",
          width: "100% !important",
          backgroundColor: "transparent !important",
          border: "none !important", 
          boxShadow: "none !important", 
          outline: "none !important", 
        },

        "& .rs-picker-toggle": {
          display: "flex !important",
          alignItems: "center !important",
          padding: "0 38px 0 16px !important",
        },

        "& .rs-picker-toggle::before, & .rs-picker-toggle::after": {
          display: "none !important",
        },

        "& .rs-picker-toggle-textbox": {
          backgroundColor: "transparent !important",
          border: "none !important",
          boxShadow: "none !important",
          outline: "none !important",
          fontSize: "0.85rem !important",
          fontWeight: "600 !important",
          color: "#334155 !important",
          padding: "0 !important",
        },

        "& .rs-picker-toggle-placeholder": {
          fontSize: "0.85rem !important",
          fontWeight: "600 !important",
        },

        "& .rs-picker-toggle-caret, & .rs-picker-toggle-clean": {
          top: "50% !important",
          transform: "translateY(-50%) !important",
          right: "12px !important",
          color: "#64748b !important",
          marginTop: "0 !important",
        },
      }}
    >
      <DatePicker
        oneTap
        value={value}
        onChange={onChange}
        placement="bottomEnd"
        format="yyyy-MM-dd"
        placeholder="Select Date"
        className="custom-rs-picker"
        cleanable={false}
        disabled={loading}
      />

      {loading && (
        <Box
          sx={{
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            display: "flex",
            alignItems: "center",
            pointerEvents: "none",
          }}
        >
          {/* <CircularProgress size={14} /> */}
        </Box>
      )}
    </Box>
  );
};